/**
 * resourceRequestInput (schema) has no origin/destination fields; saveResourceRequest
 * embeds route in description as [Route] (see graphqlService). Parse/strip for UI.
 */

function splitCityState(s) {
  if (!s) return { city: "", state: "" };
  const idx = s.lastIndexOf(",");
  if (idx <= 0) return { city: s.trim(), state: "" };
  return {
    city: s.slice(0, idx).trim(),
    state: s.slice(idx + 1).trim(),
  };
}

/** Line content after `[Route]` marker to end of string. */
export function extractRouteLine(description) {
  const raw = description != null ? String(description) : "";
  const m = raw.match(/\[Route\]\s*\n([\s\S]*)$/);
  return m ? m[1].trim() : "";
}

export function parseRouteLocationsFromDescription(description) {
  const line = extractRouteLine(description);
  if (!line) {
    return {
      locationCity: "",
      locationState: "",
      arrivalCity: "",
      arrivalState: "",
    };
  }
  const originPart = line.match(/Origin:\s*([^|]+)/)?.[1]?.trim();
  const destPart = line.match(/Destination:\s*(.+)/)?.[1]?.trim();
  const o = originPart ? splitCityState(originPart) : { city: "", state: "" };
  const d = destPart ? splitCityState(destPart) : { city: "", state: "" };
  return {
    locationCity: o.city,
    locationState: o.state,
    arrivalCity: d.city,
    arrivalState: d.state,
  };
}

/** Remove embedded [Route] block for the main description field in forms. */
export function stripRouteBlockFromDescription(description) {
  const raw = description != null ? String(description) : "";
  return raw.replace(/(?:^|\n\n)\[Route\][\s\S]*$/, "").trim();
}

/**
 * Prefer top-level fields if API returns them; otherwise parse [Route] from description.
 */
export function getRequestDisplayLocations(req) {
  if (!req || typeof req !== "object") {
    return {
      locationCity: "",
      locationState: "",
      arrivalCity: "",
      arrivalState: "",
    };
  }
  const fromApi = {
    locationCity: req.locationCity || "",
    locationState:
      req.locationState && !["Yes", "No"].includes(req.locationState)
        ? req.locationState
        : "",
    arrivalCity: req.arrivalCity || "",
    arrivalState:
      req.arrivalState && !["Yes", "No"].includes(req.arrivalState)
        ? req.arrivalState
        : "",
  };
  const fromDesc = parseRouteLocationsFromDescription(req.description);
  return {
    locationCity: fromApi.locationCity || fromDesc.locationCity,
    locationState: fromApi.locationState || fromDesc.locationState,
    arrivalCity: fromApi.arrivalCity || fromDesc.arrivalCity,
    arrivalState: fromApi.arrivalState || fromDesc.arrivalState,
  };
}
